// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductList_container__3Gka0","header":"ProductList_header__1QVCu","link":"ProductList_link__KDIOj","btn":"ProductList_btn__1PQJF","body":"ProductList_body__3K4On"};